import React, { useEffect, useState } from 'react';
import { AlertCircle } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

const TerminatedPage = ({ onRedirect }) => {
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    const redirectTimer = setTimeout(() => {
      onRedirect();
    }, 10000);
    const countdownTimer = setInterval(() => {
      setCountdown((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => {
      clearTimeout(redirectTimer);
      clearInterval(countdownTimer);
    };
  }, [onRedirect]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gradient-to-br from-slate-800 via-slate-900 to-black py-12 font-sans">
      <Card className="mx-4 w-full max-w-xl border border-white/10 bg-gradient-to-br from-slate-900 to-slate-800 text-white shadow-2xl shadow-primary/20">
        <CardContent className="flex flex-col items-center p-8 text-center sm:p-10">
          <AlertCircle
            className="mb-6 h-20 w-20 text-destructive drop-shadow-[0_0_12px_hsl(var(--destructive)/0.5)]"
            aria-hidden
          />
          <h1 className="mb-3 text-3xl font-black tracking-wide text-warning sm:text-4xl">
            Interview Terminated
          </h1>
          <p className="mb-8 max-w-lg text-base leading-relaxed text-slate-300 sm:text-lg">
            Your interview was automatically terminated because you received 3 proctoring infractions (e.g.,
            multiple faces, not facing the camera, or no face detected).
            <span className="mt-2 block">
              Please ensure you follow the proctoring guidelines in future interviews.
            </span>
          </p>
          <div className="mb-6 w-full max-w-sm rounded-lg border border-primary/30 bg-primary/10 p-4">
            <p className="text-sm text-slate-300">
              Redirecting you to your dashboard in{' '}
              <span className="font-bold text-warning">{countdown}</span> seconds…
            </p>
          </div>
          <Button
            variant="outline"
            size="lg"
            className="min-w-[200px] border-2 border-warning font-bold text-warning hover:bg-warning hover:text-slate-900"
            onClick={onRedirect}
          >
            Go to Dashboard Now
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default TerminatedPage;
